import { useTasks } from "../Tasks";

const Pull = ({ id, complete, pushed }) => {
  const { todaysDate, pullToToday } = useTasks();

  const done = () => {
    pullToToday(id);
  };

  if (pushed > todaysDate && complete === false) {
    return (
      <button className="btn up-btn" onClick={done}>
        Pull
      </button>
    );
  } else {
    return null;
  }
};

export default Pull;
